"use client";
import { Typography } from "antd";
import React from "react";

import QuestionsCollapse from "./QuestionsCollapse";

const FrequentlyAskedQuestions = () => {
  const { Title } = Typography;
  return (
    <div className="bg-regal-blue-light w-full flex flex-col gap-6 py-8 px-6 rounded-lg">
      <div className="flex flex-col items-center w-full">
        <Title level={2} className="H2 text-center">
          سوالات متداول
        </Title>
        <p className="text-regal-black-lighter text-center w-full sm:w-2/3">
          پاسخ به سوال های شما و گنجینه سوال های متداول
        </p>
      </div>
      <QuestionsCollapse />
    </div>
  );
};

export default FrequentlyAskedQuestions;
